<div class="w-full bg-white p-3 md:p-5">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

  <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-5 gap-3">
    <div>
      <h2 class="text-2xl font-bold m-0 text-900">Gestión de Entregas</h2>
      <p class="text-500 m-0 text-sm mt-1">Administra la logística de los pedidos confirmados.</p>
    </div>
    <div class="flex align-items-center gap-2 flex-wrap">
      <button pButton icon="pi pi-file-excel" label="Excel" class="p-button-outlined p-button-success border-round-3xl" (click)="exportExcel()" [loading]="exporting === 'excel'" [disabled]="exporting !== null || totalRecords === 0"></button>
      <button pButton icon="pi pi-file-pdf" label="PDF" class="p-button-outlined p-button-danger border-round-3xl" (click)="exportPdf()" [loading]="exporting === 'pdf'" [disabled]="exporting !== null || totalRecords === 0"></button>
      <button pButton icon="pi pi-refresh" label="Actualizar" class="p-button-outlined p-button-secondary border-round-3xl" (click)="loadOrders()"></button>
    </div>
  </div>

  <div class="grid mb-4 gap-3">
    <div class="col-12 md:col-6 lg:col-3">
      <div class="surface-100 p-3 border-round border-1 border-200 flex align-items-center gap-3">
        <div>
          <span class="text-500 text-xs font-bold uppercase block">Neto cobrado</span>
          <span class="text-xl font-bold text-900">{{ totalNetoCobrado | currency:'PEN':'symbol' }}</span>
        </div>
        <i class="pi pi-wallet text-3xl text-blue-500"></i>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <div class="surface-100 p-3 border-round border-1 border-200 flex align-items-center gap-3">
        <div>
          <span class="text-500 text-xs font-bold uppercase block">Comisiones MP</span>
          <span class="text-xl font-bold text-orange-600">{{ totalComisionesMp | currency:'PEN':'symbol' }}</span>
        </div>
        <i class="pi pi-percentage text-3xl text-orange-500"></i>
      </div>
    </div>
  </div>

  <div class="mb-4 flex align-items-end gap-2 flex-wrap">
    <div class="field m-0">
      <label class="font-semibold text-sm text-700 block mb-1">Filtrar por tipo de envío</label>
      <p-select [options]="tipoEnvioFilterOptions" [(ngModel)]="tipoEnvioFilterId" (onChange)="reloadFirst()" optionLabel="label" optionValue="value"
        placeholder="Todos" styleClass="border-round-lg" [style]="{'min-width':'220px'}" appendTo="body"></p-select>
    </div>
    <div class="field m-0">
      <label class="text-xs font-semibold text-600 block mb-1">Hoja de empaque</label>
      <p-select [options]="packingPerPageOptions" [(ngModel)]="packingPerPage"
        optionLabel="label" optionValue="value" appendTo="body"
        styleClass="border-round-lg" [style]="{'min-width':'140px'}"></p-select>
    </div>
    <div class="field m-0">
      <label class="text-xs font-semibold text-600 block mb-1">Estado impresión</label>
      <p-select [options]="packingStatusOptions" [(ngModel)]="packingPrintFilter" (onChange)="reloadFirst()"
        optionLabel="label" optionValue="value" appendTo="body"
        styleClass="border-round-lg" [style]="{'min-width':'150px'}"></p-select>
    </div>
    <button pButton type="button" icon="pi pi-print" label="Imprimir seleccionados"
      class="p-button-outlined border-round-lg"
      (click)="printSelected()" [disabled]="!selectedOrders.length"></button>
    <button pButton type="button" icon="pi pi-clone" label="Últimos 3"
      class="p-button-outlined p-button-secondary border-round-lg"
      (click)="printLastThree()" [disabled]="filteredOrders.length === 0"></button>
  </div>
  <div class="mb-3 text-sm text-600" *ngIf="selectedOrders.length">
    {{ selectedOrders.length }} pedido(s) seleccionado(s)
  </div>

  <p-table [value]="filteredOrders" [lazy]="true" (onLazyLoad)="loadOrders($event)"
           [first]="first" [rows]="rows" [totalRecords]="totalRecords" [paginator]="true"
           [rowsPerPageOptions]="[10, 25, 50]"
           [loading]="loading" responsiveLayout="scroll" [rowHover]="true"
           styleClass="p-datatable-sm" dataKey="id" [(selection)]="selectedOrders" [selectionMode]="'multiple'">
    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th style="width: 40px"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
        <th style="width: 110px">Fecha de registro</th>
        <th style="width: 110px">ID</th>
        <th style="width: 110px">Fecha de entrega</th>
        <th>Cliente</th>
        <th style="width: 140px">Tipo de Envío</th>
        <th>Destino</th>
        <th style="width: 120px">Pago</th>
        <th>Estado Actual</th>
        <th style="width: 220px">Acción</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-order>
      <tr class="transition-colors hover:surface-50">
        <td><p-tableCheckbox [value]="order"></p-tableCheckbox></td>
        <td class="text-sm text-600">{{ order.createdAt | peruDate:'dd/MM/yyyy HH:mm' }}</td>
        <td class="font-bold text-900">#{{ order.id }}</td>
        <td class="text-sm">{{ order.scheduledDate | peruDate:'dd/MM/yyyy' }}<span class="text-xs block" *ngIf="order.scheduledTime">{{ order.scheduledTime }}</span></td>
        <td>
          <div class="font-bold text-900 text-sm">{{ order.clientName }}</div>
          <div class="text-xs text-500"><i class="pi pi-phone text-xs mr-1"></i>{{ order.clientPhone }}</div>
        </td>
        <td>
          <p-tag [value]="order.tipoEnvio?.nombreTipoEnvio || order.deliveryMethod || '—'" severity="info" [rounded]="true"></p-tag>
        </td>
        <td>
          <div class="font-bold text-900 text-sm">{{ order.distrito?.nombre || order.district }}</div>
          <div class="text-xs text-600">{{ order.deliveryAddress }}</div>
          <div class="text-xs text-400 italic mt-1" *ngIf="order.reference">Ref: {{ order.reference }}</div>
        </td>
        <td>
          <div class="flex flex-column gap-1">
            <p-tag [value]="getPaymentStatusLabel(order.paymentStatus)" [severity]="getPaymentSeverity(order.paymentStatus)" [rounded]="true" styleClass="w-max"></p-tag>
            <span class="text-xs text-600">Adel.: {{ (order.amountPaid ?? 0) | currency:'PEN':'symbol' }}</span>
            <span *ngIf="(order.totalAmount ?? 0) - (order.amountPaid ?? 0) > 0" class="text-xs text-orange-600 font-bold">Debes {{ ((order.totalAmount ?? 0) - (order.amountPaid ?? 0)) | currency:'PEN':'symbol' }}</span>
          </div>
        </td>
        <td>
          <p-tag [value]="order.status" [severity]="getSeverity(order.status)" [rounded]="true"></p-tag>
        </td>
        <td>
          <button pButton icon="pi pi-print" class="p-button-rounded p-button-text p-button-secondary mr-1"
            pTooltip="Imprimir hoja de empaque" tooltipPosition="top" (click)="printOne(order)"></button>
          <button pButton icon="pi pi-eye" class="p-button-rounded p-button-text p-button-secondary mr-1" pTooltip="Ver Detalle" tooltipPosition="top" (click)="openDetails(order)"></button>
          <p-select *ngIf="editingStatusId === order.id" [options]="statusOptions(order)" [ngModel]="order.status" (ngModelChange)="updateStatus(order, $event)"
            appendTo="body" placeholder="Estado" [style]="{'width':'100%'}" styleClass="mt-1">
            <ng-template let-item pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div [ngClass]="{'w-2 h-2 border-circle': true, 'bg-blue-500': item.value === 'CONFIRMADO', 'bg-yellow-500': item.value === 'EN_PREPARACION', 'bg-purple-500': item.value === 'EN_RUTA', 'bg-green-500': item.value === 'ENTREGADO'}"></div>
                <span class="text-sm">{{ item.label }}</span>
              </div>
            </ng-template>
          </p-select>
          <button *ngIf="editingStatusId !== order.id" pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary"
            pTooltip="Cambiar estado" tooltipPosition="top" (click)="editingStatusId = order.id"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="10" class="text-center p-5 text-500">No hay pedidos para este filtro.</td></tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="detailsDialog" [style]="{width: '850px'}" header="Detalle del Pedido #{{selectedOrder?.id}}" [modal]="true" styleClass="p-fluid">
  <div *ngIf="selectedOrder" class="grid">
    <div [ngClass]="selectedOrder.paymentChannel === 'MERCADOPAGO' ? 'col-12' : 'col-12 md:col-5'">
      <div class="p-3 border-1 border-gray-200 border-round bg-gray-50 h-full">
        <div class="mb-3 border-bottom-1 border-gray-200 pb-2">
          <span class="block text-600 text-sm mb-1 font-bold uppercase">Cliente</span>
          <span class="block font-bold text-xl">{{ selectedOrder.clientName }}</span>
          <div class="flex align-items-center mt-1 text-primary"><i class="pi pi-whatsapp mr-1"></i><span>{{ selectedOrder.clientPhone }}</span></div>
          <div *ngIf="selectedOrder.dni" class="text-sm text-700 mt-1"><span class="font-semibold">DNI:</span> {{ selectedOrder.dni }}</div>
          <div *ngIf="selectedOrder.email" class="text-sm text-600 mt-1" style="word-break: break-all;">{{ selectedOrder.email }}</div>
        </div>
        <div class="mb-3 border-bottom-1 border-gray-200 pb-2">
          <span class="block text-600 text-sm mb-1 font-bold uppercase">Entrega</span>
          <p-tag [value]="selectedOrder.tipoEnvio?.nombreTipoEnvio || selectedOrder.deliveryMethod" [severity]="selectedOrder.deliveryMethod === 'DELIVERY' ? 'success' : 'warn'"></p-tag>
          <div class="mt-2 text-sm">
            <div class="font-bold text-800">{{ selectedOrder.distrito?.nombre || selectedOrder.district }}</div>
            <div class="text-700 my-1"><i class="pi pi-map-marker text-red-500 mr-1"></i>{{ selectedOrder.deliveryAddress }}</div>
            <div *ngIf="selectedOrder.reference" class="text-600 bg-white p-2 border-round text-xs"><strong>Ref:</strong> {{ selectedOrder.reference }}</div>
          </div>
        </div>
        <div *ngIf="selectedOrder.deliveryMethod === 'PUNTO' || selectedOrder.deliveryMethod === 'RECOJO_PUNTO'" class="mb-3 border-bottom-1 border-gray-200 pb-3 bg-blue-50 p-2 border-round">
          <span class="block text-blue-800 text-sm mb-2 font-bold uppercase"><i class="pi pi-calendar mr-1"></i> Agendar Entrega</span>
          <div class="flex flex-column gap-2">
            <div class="w-full"><label class="text-xs text-600 block mb-1">Fecha</label>
              <p-datepicker [(ngModel)]="tempDate" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="Seleccionar día" appendTo="body" styleClass="w-full" inputStyleClass="text-sm w-full"></p-datepicker>
            </div>
            <div class="w-full">
              <label class="text-xs text-600 block mb-1">Hora</label>
              <p-datepicker [(ngModel)]="tempTime" [timeOnly]="true" hourFormat="12" [stepMinute]="15" placeholder="Hora" appendTo="body" styleClass="w-full" inputStyleClass="text-sm w-full"></p-datepicker>
            </div>
          </div>
          <button pButton label="Guardar Cita" icon="pi pi-check" class="p-button-sm p-button-outlined mt-2 w-full" (click)="saveSchedule()" [disabled]="!tempDate || !tempTime"></button>
          <div *ngIf="selectedOrder.scheduledDate" class="mt-2 text-center text-xs text-green-700 font-bold"><i class="pi pi-check-circle"></i> Agendado: {{ selectedOrder.scheduledDate | peruDate:'dd/MM/yyyy' }} - {{ selectedOrder.scheduledTime }}</div>
        </div>
        <app-mp-payment-panel *ngIf="selectedOrder.paymentChannel === 'MERCADOPAGO'" [order]="selectedOrder"></app-mp-payment-panel>
        <div class="mb-1">
          <span class="block text-600 text-sm mb-2 font-bold uppercase">Productos</span>
          <ul class="list-none p-0 m-0">
            <li *ngFor="let item of selectedOrder.items" class="p-2 border-1 border-gray-200 border-round mb-2 bg-white flex flex-column">
              <div class="font-bold text-900">{{ item.quantity }} x {{ item.productName || item.product?.productName || item.product?.name || 'Producto' }}</div>
              <div class="text-sm text-600 mt-1 flex gap-2">
                <span *ngIf="item.size" class="bg-gray-100 px-2 border-round">Talla: {{ item.size }}</span>
                <span *ngIf="item.color" class="bg-gray-100 px-2 border-round">Color: {{ item.color }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div *ngIf="selectedOrder.notes" class="mt-3 p-2 bg-yellow-50 border-1 border-yellow-200 border-round text-sm"><span class="font-bold text-yellow-800">Nota:</span> {{ selectedOrder.notes }}</div>
      </div>
    </div>
    <div *ngIf="selectedOrder.paymentChannel !== 'MERCADOPAGO'" class="col-12 md:col-7 flex flex-column align-items-center justify-content-center bg-black-alpha-90 border-round p-3" style="min-height: 500px;">
      <div class="text-white mb-2 text-sm"><i class="pi pi-image mr-1"></i> Comprobante de Pago</div>
      <p-image *ngIf="selectedOrder.paymentProof" [src]="selectedOrder.paymentProof | imgUrl" alt="Voucher" [preview]="true" width="100%" styleClass="w-full flex justify-content-center" class="shadow-2 border-round" [style]="{'max-height': '450px', 'object-fit': 'contain'}"></p-image>
      <div *ngIf="!selectedOrder.paymentProof" class="text-gray-400 flex flex-column align-items-center"><i class="pi pi-image text-5xl mb-2"></i><span>No hay imagen disponible</span></div>
      <a *ngIf="selectedOrder.paymentProof" [href]="selectedOrder.paymentProof | imgUrl" target="_blank" class="text-blue-300 text-sm mt-3 hover:text-white underline cursor-pointer"><i class="pi pi-external-link mr-1"></i> Abrir en nueva pestaña</a>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton label="Cerrar" icon="pi pi-times" class="p-button-secondary" (click)="detailsDialog = false"></button>
  </ng-template>
</p-dialog>
